import { setupI18n } from '@lingui/core';

import en from '../../locales/en/messages';

const catalogs = {
  en,
};

export const i18n = setupI18n({ catalogs, language: 'en' });
